<!--  -->
<template>
  <div>

    <el-form :label-position="'right'" label-width="80px">
      <el-form-item label="时间">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="pickerTime"
        />
      </el-form-item>
      <el-form-item label="账号">
        <div style="display: flex">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="chooseoperatetwo"
            >选择</el-button>
          </div>
          <div style="margin-left: 10px;">
            <el-button
              v-show="allaccount_ids.length !== 0"
              type="warning"
              size="mini"
              @click="allaccount_ids = []"
            >清空</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <div v-show="allaccount_ids.length !== 0" style="max-height: 200px; overflow-y: scroll; position: relative">
          <el-tag
            v-for="(itemrse, indexr) in allaccount_ids"
            :key="indexr"
            style="margin-right: 10px; margin-bottom: 5px"
            closable
            :type="'success'"
            @close="rightclicktwo(itemrse, indexr)"
          >
            {{ itemrse.account_name }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="brwbtn" @click="addbtn">确 定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择账号"
      :visible.sync="dialogAccountIds"
      width="50%"
      append-to-body
    >
      <accoutDetail ref="ids" @bandarr="bandarrtwo" />
    </el-dialog>
  </div>
</template>

<script>
import { exportTFigureListmonry } from '@/api/shortPlayReport.js'
import accoutDetail from './accoutDetail.vue'
export default {
  components: { accoutDetail },
  data() {
    return {
      timeValue: [],
      start_time: '',
      end_time: '',
      dialogAccountIds: false,
      allaccount_ids: [],
      account_ids: [],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date()
          const twoYearsAgo = new Date()
          twoYearsAgo.setFullYear(today.getFullYear() - 2)
          // 往后加 2 天
          twoYearsAgo.setTime(twoYearsAgo.getTime() + 2 * 24 * 60 * 60 * 1000)

          return time.getTime() > today.getTime() || time.getTime() < twoYearsAgo.getTime()
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    // 选择时间
    pickerTime() {
      if (!this.timeValue) return
      const [start_time, end_time] = this.timeValue
      this.start_time = start_time
      this.end_time = end_time
    },
    addbtn() {
      // eslint-disable-next-line eqeqeq
      if (this.timeValue.length == 0) {
        this.$message.error('请选择时间')
        return
      }
      if (this.allaccount_ids.length === 0) {
        this.$message.info('请选择账号')
        return
      }
      console.log(this.start_time, this.end_time)
      this.account_ids = []
      this.account_ids = this.allaccount_ids.map(v => v.account_id)
      exportTFigureListmonry({
        start_time: this.start_time,
        end_time: this.end_time,
        account_ids: this.account_ids
      }).then((res) => {
        console.log('res', res)
        this.$emit('fundupdata')
        this.$message({
          message: '导出成功',
          type: 'success'
        })
      })
    },
    chooseoperatetwo() {
      this.dialogAccountIds = true
      this.$nextTick(() => {
        this.$refs.ids.sendr(this.allaccount_ids, 1, 2)
      })
    },
    bandarrtwo(arr) {
      this.dialogAccountIds = false
      console.log('arr', arr)
      this.allaccount_ids = []
      this.allaccount_ids = arr
    },
    rightclicktwo(item, indexr, index) {
      console.log(item, indexr)
      this.allaccount_ids.splice(indexr, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
